import { BaseFieldConfig, ComponentNameEnum } from '@/types';

const lineHeightFieldConfig: BaseFieldConfig = {
  componentName: ComponentNameEnum.LINE_HEIGHT,
  options: {
    defaultValue: '1.3',
  },
};
export default lineHeightFieldConfig;
